/**
 * Global game configuration.
 *
 * GAME-ONLY CONSTANTS. The glucose "physics" here are gameplay values chosen
 * to make the teaching loop work — they are NOT a medical model of anyone's
 * body, and nothing in this app may be used for real dosing decisions.
 */

export const GAME_WIDTH = 960;
export const GAME_HEIGHT = 600;

/** Glucose display unit for the UI. Game logic always works internally in mg/dL. */
export type GlucoseUnit = 'mg/dL' | 'mmol/L';
export const DISPLAY_UNIT: GlucoseUnit = 'mmol/L';

const MGDL_PER_MMOL = 18.0182;

export function mgdlToMmol(mgdl: number): number {
  return mgdl / MGDL_PER_MMOL;
}

export function mmolToMgdl(mmol: number): number {
  return mmol * MGDL_PER_MMOL;
}

/** Format a mg/dL value for display in the configured UI unit. */
export function displayGlucose(mgdl: number): string {
  if (DISPLAY_UNIT === 'mmol/L') {
    return `${mgdlToMmol(mgdl).toFixed(1)} mmol/L`;
  }
  return `${Math.round(mgdl)} mg/dL`;
}

/** Demo starting glucose for the vertical-slice quest (mg/dL). */
export const DEMO_START_GLUCOSE_MGDL = 165;

/** localStorage key for best XP. */
export const BEST_XP_KEY = 'carbquest.bestXp';
